import Backbone from '@polleverywhere/backbone'

// @namespace Model
class FTPResult extends Backbone.Model {}

export default FTPResult
